/**
 * Build initials for owner select labels (e.g. "MS" from "Max Schmidt").
 * @param {string} name
 */
export function buildUserInitials(name) {
  const trimmed = String(name || '').trim();
  if (!trimmed) return '??';

  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
  }

  return trimmed.slice(0, 2).toUpperCase();
}

/**
 * PDF-style owner options: "Ich selbst (Lea)" for current user, "MS — Max Schmidt" for others.
 * Current user is listed first.
 *
 * @param {Array<{ id: string, name?: string, email?: string, label?: string }>} users
 * @param {string | null | undefined} currentUserId
 * @param {(key: string, params?: object) => string} translate
 */
export function buildCommitmentOwnerSelectOptions(users, currentUserId, translate) {
  const normalizedCurrentId = String(currentUserId || '');

  const options = (users || []).map((user) => {
    const id = String(user.id);
    const displayName = user.name || user.email || user.label || id;
    const isSelf = normalizedCurrentId && id === normalizedCurrentId;
    const label = isSelf
      ? translate('UserProjects.commitmentDialog.ownerSelf', { name: displayName })
      : `${buildUserInitials(displayName)} — ${displayName}`;

    return { label, value: id, isSelf, email: user.email || '' };
  });

  return options.sort((a, b) => {
    if (a.isSelf && !b.isSelf) return -1;
    if (!a.isSelf && b.isSelf) return 1;
    return a.label.localeCompare(b.label);
  });
}
